import {
    UI_SPORT_PRE_ACTIVE_SPORT,
    UI_SPORT_PRE_EVENTS_BY_SPORT_AND_TIME,
    UI_SPORT_PRE_SEARCH_TEXT,
} from 'constants/ui';
import { isTerminal } from 'utils/UiHelper';

export function setActiveSportId(id) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_PRE_ACTIVE_SPORT,
            payload: id.toString(),
        });
    };
}

export function setEventsBySportAndTime(events, timeRange) {
    let data = {};

    for (let item of events) {
        /* skip event if it contains 'vinderpil' markets */
        if (isTerminal()) {
            let isVinderspil = item.marketList.find((item) => {
                return item.marketTypeGroup === 11;
            });

            if (isVinderspil) {
                continue;
            }
        }
        /* */

        if (!data[item.sportId]) {
            data[item.sportId] = {};
        }

        let tmpKickoff = item.kickoffTime.split(':');

        if (!data[item.sportId][tmpKickoff[0]]) {
            data[item.sportId][tmpKickoff[0]] = [];
        }

        data[item.sportId][tmpKickoff[0]].push(item);
    }

    return (dispatch) => {
        dispatch({
            type: UI_SPORT_PRE_EVENTS_BY_SPORT_AND_TIME,
            payload: data,
        });
    };
}

export function search(text) {
    return (dispatch) => {
        dispatch({
            type: UI_SPORT_PRE_SEARCH_TEXT,
            payload: text,
        });
    };
}
